export interface INationalities {
  code: string;
  description: string;
}
export const Nationalities = [
  {
    code: 'SG',
    description: 'Singapore'
  },
  {
    code: 'AR',
    description: 'Argentina'
  },
  {
    code: 'AU',
    description: 'Australia'
  },
  {
    code: 'AT',
    description: 'Austria'
  },
  {
    code: 'BH',
    description: 'Bahrain'
  },
  {
    code: 'BE',
    description: 'Belgium'
  },
  {
    code: 'BR',
    description: 'Brazil'
  },
  {
    code: 'BN',
    description: 'Brunei'
  },
  {
    code: 'CA',
    description: 'Canada'
  },
  {
    code: 'CN',
    description: 'China'
  },
  {
    code: 'CZ',
    description: 'Czech Republic'
  },
  {
    code: 'DK',
    description: 'Denmark'
  },
  {
    code: 'FI',
    description: 'Finland'
  },
  {
    code: 'FR',
    description: 'France'
  },
  {
    code: 'DD',
    description: 'Germany'
  },
  {
    code: 'GR',
    description: 'Greece'
  },
  {
    code: 'HK',
    description: 'Hong Kong'
  },
  {
    code: 'IS',
    description: 'Iceland'
  },
  {
    code: 'IN',
    description: 'India'
  },
  {
    code: 'ID',
    description: 'Indonesia'
  },
  {
    code: 'IE',
    description: 'Ireland'
  },
  {
    code: 'IT',
    description: 'Italy'
  },
  {
    code: 'JP',
    description: 'Japan'
  },
  {
    code: 'JO',
    description: 'Jordan'
  },
  {
    code: 'KE',
    description: 'Kenya'
  },
  {
    code: 'KW',
    description: 'Kuwait'
  },
  {
    code: 'LB',
    description: 'Lebanon'
  },
  {
    code: 'LI',
    description: 'Liechtenstein'
  },
  {
    code: 'LU',
    description: 'Luxembourg'
  },
  {
    code: 'MY',
    description: 'Malaysia'
  },
  {
    code: 'MT',
    description: 'Malta'
  },
  {
    code: 'MC',
    description: 'Monaco'
  },
  {
    code: 'MM',
    description: 'Myanmar'
  },
  {
    code: 'NZ',
    description: 'New Zealand'
  },
  {
    code: 'NO',
    description: 'Norway'
  },
  {
    code: 'OM',
    description: 'Oman'
  },
  {
    code: 'PK',
    description: 'Pakistan'
  },
  {
    code: 'PH',
    description: 'Philippines'
  },
  {
    code: 'PL',
    description: 'Poland'
  },
  {
    code: 'PT',
    description: 'Portugal'
  },
  {
    code: 'QA',
    description: 'Qatar'
  },
  {
    code: 'RU',
    description: 'Russia'
  },
  {
    code: 'SA',
    description: 'Saudi Arabia'
  },
  {
    code: 'ZA',
    description: 'South Africa'
  },
  {
    code: 'KR',
    description: 'South Korea'
  },
  {
    code: 'ES',
    description: 'Spain'
  },
  {
    code: 'LK',
    description: 'Sri Lanka'
  },
  {
    code: 'SE',
    description: 'Sweden'
  },
  {
    code: 'CH',
    description: 'Switzerland'
  },
  {
    code: 'TW',
    description: 'Taiwan (R.O.C)'
  },
  {
    code: 'TZ',
    description: 'Tanzania'
  },
  {
    code: 'TH',
    description: 'Thailand'
  },
  {
    code: 'NL',
    description: 'The Netherlands'
  },
  {
    code: 'AE',
    description: 'United Arab Emirates'
  },
  {
    code: 'GB',
    description: 'United Kingdom'
  },
  {
    code: 'US',
    description: 'United States'
  },
  {
    code: 'VN',
    description: 'Vietnam'
  },
  
];